import envVariables from "src/lib/envVariables";
import reportErrorSentry from "src/lib/reportErrorSentry";
import { authenticationState } from "src/state/state";

import type { FileTransferConfig } from "@9amhealth/shared";

/**
 * File transfer configuration for the user-app.
 * This adapts the app-specific dependencies (env vars, auth, error reporting)
 * to the generic FileTransferConfig interface from the shared package.
 *
 * Usage:
 * ```typescript
 * import { fileTransferConfig } from "src/lib/fileTransferConfig";
 * import { downloadFileWithProgress } from "@9amhealth/shared";
 *
 * const blob = await downloadFileWithProgress(fileId, fileTransferConfig, {
 *   onProgress: (loaded, total, percentage) => {
 *     console.log(`Downloaded ${percentage}%`);
 *   }
 * });
 * ```
 */
export const fileTransferConfig: FileTransferConfig = {
  apiBaseUrl: envVariables.API_BASE_URL,
  getAccessToken: () => authenticationState.accessToken || "",
  onError: (error: Error) => reportErrorSentry(error)
};
